import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=123d8944&scoped=true"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordDialog.vue?vue&type=style&index=0&id=123d8944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d8944",
  null
  
)

export default component.exports